import { Component } from '@angular/core';
import { LayoutModule } from '@rockwell-automation-inc/layout';

@Component({
  selector: 'app-error-login',
  styleUrls: ['./error-login.component.scss'],
  templateUrl: './error-login.component.html',
  imports: [LayoutModule],
})
export class ErrorLoginComponent {}
